import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useAdminSettings() {
  const [settings, setSettings] = useState(null);
  const load = useCallback(() => api.get("/admin/settings").then((r) => setSettings(r.data)), []);
  useEffect(() => { load().catch(() => {}); }, [load]);
  const save = async (patch, msg = "Saved") => {
    try {
      const { data } = await api.put("/admin/settings", patch);
      setSettings(data);
      toast.success(msg);
      return true;
    } catch (e) {
      toast.error(errMsg(e));
      return false;
    }
  };
  return { settings, save, reload: load };
}

export const PageHeader = ({ title, sub, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
    <div>
      <h1 className="font-display text-3xl font-bold text-maroon">{title}</h1>
      {sub && <p className="mt-1 text-sm text-ink-muted">{sub}</p>}
    </div>
    {children}
  </div>
);

export const Panel = ({ className = "", children, ...rest }) => (
  <div className={`rounded-2xl border border-gold/40 bg-white p-5 ${className}`} {...rest}>{children}</div>
);
